import { render } from "./MessageFiles.vue?vue&type=template&id=77c5e242&scoped=true"
import script from "./MessageFiles.vue?vue&type=script&lang=js"
export * from "./MessageFiles.vue?vue&type=script&lang=js"

import "./MessageFiles.vue?vue&type=style&index=0&id=77c5e242&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\external\\kazigraphix\\admin.kazigraphix\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c5e242"]])

export default __exports__